var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({key:_vm.spriteHref,class:['gl-icon'],attrs:{"data-testid":(_vm.name + "-icon"),"role":"img","height":_vm.size,"width":_vm.size}},_vm.$listeners),[_c('use',{attrs:{"href":_vm.spriteHref}})])}
var staticRenderFns = []

export { render, staticRenderFns }